import { useReducer } from 'react';

interface SSOState {
  ssoEnabled: boolean;
  removeSso: boolean;
}

type SSOAction =
  | { type: 'TOGGLE_SSO' }
  | { type: 'REMOVE_SSO' }
  | { type: 'INITIALIZE'; payload: { ssoEnabled: boolean } };

function ssoReducer(state: SSOState, action: SSOAction): SSOState {
  switch (action.type) {
    case 'TOGGLE_SSO':
      return {
        ...state,
        ssoEnabled: !state.ssoEnabled,
        removeSso: false,
      };
    case 'REMOVE_SSO':
      return {
        ...state,
        ssoEnabled: false,
        removeSso: true,
      };
    case 'INITIALIZE':
      return {
        ...state,
        ssoEnabled: action.payload.ssoEnabled,
        removeSso: false,
      };
    default:
      return state;
  }
}

export const useSSO = (initialSsoEnabled: boolean = false) => {
  const [ssoState, dispatch] = useReducer(ssoReducer, {
    ssoEnabled: initialSsoEnabled,
    removeSso: false,
  });

  const toggleSSO = () => dispatch({ type: 'TOGGLE_SSO' });
  const removeSSO = () => dispatch({ type: 'REMOVE_SSO' });
  const initializeSSO = (ssoEnabled: boolean) => dispatch({ type: 'INITIALIZE', payload: { ssoEnabled } });

  return {
    ssoState,
    toggleSSO,
    removeSSO,
    initializeSSO,
  };
};
